<template>
  <v-container
    id="movimentacaoContasSemanal"
  >
    <div>
      <v-row v-if="loading">
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <div
            :style="styleObject"
            class="text-center"
          >
            <v-icon
              light
              class="custom-loader"
              :style="styleObject"
            >
              mdi-cached
            </v-icon>
            Carregando dados...
          </div>
        </v-col>
      </v-row>
      <v-row v-else-if="error">
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <div
            class="alert alert-danger"
          >
            {{ error }}
          </div>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <v-row>
            <v-col
              id="justificativaId"
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              JUSTIFICATIVA
            </v-col>
          </v-row>
          <v-row
            id="linhaTabelaJustifiva"
          >
            <v-col
              id="tabelaJustificativa"
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-data-table
                :headers="headersProjecaoSemanalJustificativa"
                :items="projecaoSemanalJustificativa"
                :items-per-page="projecaoSemanalJustificativa.length"
                hide-default-footer
                disable-sort
                class="elevation-1"
                style="color: black"
              >
                <template v-slot:[`item.valor`]="{ item }">
                  <td
                    class="text-right title"
                    :style="getColorTable(item.valor)"
                  >
                    <span>
                      {{ item.valor }}
                    </span>
                  </td>
                </template>
                <template v-slot:[`item.observacao`]="{ item }">
                  <td
                    class="text-right title"
                  >
                    <span>
                      {{ item.observacao }}
                    </span>
                  </td>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  import FluxoCaixa from '../../../../../services/fluxocaixa'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowJustificativaMovimentacao',
    emits: [],
    components: {
    },
    data: () => ({
      styleObject: {
        color: '#4CAF50',
      },
      styleSaldoBancario: {
        color: '#4CAF50',
      },
      loading: false,
      error: null,
      select: [],
      projecaoSemanalJustificativa: [],
      headersProjecaoSemanalJustificativa: [
        { text: 'Valor', value: 'valor', width: '100px', align: 'right', class: 'black--text title' },
        { text: 'Observação', value: 'observacao', width: '200px', align: 'right', class: 'black--text title' },
      ],
    }),

    created () {
      eventEmit.$on('update-fluxo', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-fluxo', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (select) {
        this.select = select

        this.showDadosJustificativaMovimentacaoSemanal()
      },

      async showDadosJustificativaMovimentacaoSemanal () {
        this.loading = true

        this.projecaoSemanalJustificativa = []

        await FluxoCaixa.showJustificativaMovimentacao(localStorage.username, localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.projecaoSemanalJustificativa = resposta.data.dadosMovimentacao.map((item) => {
              var listaJustificativa = ({
                observacao: item.observacao,
                valor: item.saldo ? parseFloat(item.saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '',
              })

              return listaJustificativa
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      getColorTable (value) {
        var negativo = value.substr(0, 1)

        if (negativo === '-') {
          return 'color: #f27686'
        } else {
          return 'color: #4CAF50'
        }
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #movimentacaoContasSemanal {
    max-width: 100%
  }

  #formaterDados {
    font-size: 11px
  }

  #justificativaId {
    margin: 0.7rem 0rem 0rem 0rem;
    border: double;
  }

  /* #linhaTabelaJustifiva {

  } */

  #tabelaJustificativa {
    margin: -0.5rem 0rem 0rem -1rem;
  }
</style>
